import React from 'react';
import LogosManager from '../Components/Catalogos/Logos/LogosManager';

/**
 * LogosPage - Página principal para la gestión de logotipos y favicon.
 * Muestra el gestor visual (Grid Layout - Tarjetas).
 */
export default function LogosPage() {
    return (
        <LogosManager />
    );
}
